<template>
  <div>
    <b-container>
      <b-card class="mt-4 pb-0">
        <h2 class="text-center text-primary font-size-20 font-weight-bold position-relative main-header mb-5">
          {{ $t('auth.connectWith') }}</h2>
        <div class="contact-info px-4 mb-4">
          <div class="contact-info-item d-flex align-items-start mb-3">
            <i class="las la-map-marked-alt text-primary font-size-24 ml-3"></i>
            <div>
              <span class="font-weight-bold d-block mb-1">{{ $t('auth.address') }}</span>
              <a
                :href="contactInfo.locationUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="text-primary"
              >{{ $t('endUser.contactAddress') }}</a>
            </div>
          </div>
          <div class="contact-info-item d-flex align-items-start mb-3">
            <i class="las la-phone text-primary font-size-24 ml-3"></i>
            <div>
              <span class="font-weight-bold d-block mb-1">{{ $t('endUser.tel') }}</span>
              <a :href="'tel:+' + contactInfo.phone" @click.prevent class="text-primary"><span dir="ltr">+{{ contactInfo.phone }}</span></a>
            </div>
          </div>
          <div class="contact-info-item d-flex align-items-start mb-3">
            <i class="las la-envelope text-primary font-size-24 ml-3"></i>
            <div>
              <span class="font-weight-bold d-block mb-1">{{ $t('auth.email') }}</span>
              <a :href="'mailto:' + contactInfo.email" class="text-primary">{{ contactInfo.email }}</a>
            </div>
          </div>

        </div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form class="position-relative form-top p-4" @submit.prevent="handleSubmit(contactUs)">
            <b-row>
              <b-col md="6">
                <input-form
                    class="mb-3"
                    v-model="contact.name"
                    :validate="'required'"
                    :placeholder="$t('auth.fullName')"
                    :name="$t('auth.fullName')"
                    type="text"
                    :label="$t('auth.fullName')"
                />
              </b-col>
              <b-col md="6">
                <input-form
                    class="mb-3"
                    v-model="contact.email"
                    :validate="'required|email'"
                    :placeholder="$t('auth.email')"
                    :name="$t('auth.email')"
                    type="email"
                    :label="$t('auth.email')"
                />
              </b-col>
              <b-col md="12">
                <b-form-group :label="$t('auth.messageText')">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('auth.messageText')"
                    rules="required"
                  >
                    <textarea
                      :placeholder="$t('auth.messageText')"
                      v-model="contact.message"
                      :class="['form-control msg d-block w-100', { 'is-invalid': errors.length > 0 }]"
                    ></textarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12" class="mt-4">
                <div class="d-flex justify-content-center">
                  <b-button variant="primary" type="submit" class="px-5 py-2 iq-border-radius-5">{{ $t('auth.send') }}</b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
export default {
  name: 'contact us',
  mounted () {
    core.index()
  },
  methods: {
    contactUs () {
      const { name, email, message } = this.contact
      const subject = encodeURIComponent(`${this.$t('endUser.contactUs')} - ${name}`)
      const body = encodeURIComponent(
        `${this.$t('auth.fullName')}: ${name}\n${this.$t('auth.email')}: ${email}\n\n${this.$t('auth.messageText')}:\n${message}`
      )
      window.location.href = `mailto:${this.contactInfo.email}?subject=${subject}&body=${body}`
      core.showSnackbar('success', this.$t('endUser.contactMessageOpened'))
    }
  },
  data () {
    return {
      contactInfo: {
        locationUrl: 'https://maps.app.goo.gl/ETv3Fv3cgJ6KyuPQ9?g_st=iwb',
        phone: '966115138351',
        email: 'info@ibbil.com'
      },
      contact: {
        name: '',
        email: '',
        message: ''
      }
    }
  }
}
</script>
